/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Seat_ChangesInputs */



/**
* | output |
* | --- |
* | "Seat changes this period" |
*
* @param {Billing_Seat_ChangesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_seat_changes = /** @type {((inputs?: Billing_Seat_ChangesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Seat_ChangesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sitzplatzänderungen in diesem Zeitraum")
	return /** @type {LocalizedString} */ ("Seat changes this period")
});